<section aria-live="polite" class="container">
	<div class="header">
		<h2>Vestigingen</h2>
		<div class="export-container right">
			<div class="spinner">
				@if (showExportSpinner$ | async) {
					<app-css-spinner></app-css-spinner>
				}
			</div>
			<app-icon
				name="export"
				color="primary-1"
				hoverColor="primary-1"
				size="large"
				[class.hidden]="showExportSpinner$ | async"
				(click)="export()"
			></app-icon>
		</div>
	</div>
	<div class="controls">
		@if ({ value: filter$ | async }; as filter) {
			<div class="left">
				<app-instant-search-box [value]="filter.value!" (fire)="search($event)"></app-instant-search-box>
			</div>
		}
	</div>
	<div class="list">
		@if (alleVestigingen$ | async; as vestigingen) {
			@if (accounts$ | async; as accounts) {
				<table>
					<thead>
						<tr>
							<th class="naam">Naam</th>
							@for (vestiging of vestigingen; track vestiging.rVestiging.vestigingId; let columnIndex = $index) {
								<th
									class="vestiging"
									[class.inactief]="!vestiging.rVestiging.actief"
									[class.column-hover]="hoveredColumnIndex === columnIndex"
									[appTooltip]="getTooltip(vestiging)"
									(mouseenter)="onHover(undefined, columnIndex)"
									(mouseleave)="onHover(undefined, undefined)"
								>
									{{ vestiging.rVestiging.naam }}
									@if (!vestiging.rVestiging.actief) {
										(Inactief)
									}
								</th>
							}
						</tr>
					</thead>
					<tbody>
						@for (account of accounts; track account.id; let rowIndex = $index) {
							<tr>
								@if (getAccountNaam(account); as naam) {
									<td
										class="naam"
										[class.row-hover]="hoveredRowIndex === rowIndex"
										[appTooltip]="naam"
										(mouseenter)="onHover(rowIndex, undefined)"
										(mouseleave)="onHover(undefined, undefined)"
									>
										{{ naam }}
									</td>
								}
								@for (vestiging of vestigingen; track vestiging.rVestiging.vestigingId; let columnIndex = $index) {
									<td
										[class.row-hover]="hoveredRowIndex === rowIndex"
										[class.column-hover]="hoveredColumnIndex === columnIndex"
										(mouseenter)="onHover(rowIndex, columnIndex)"
										(mouseleave)="onHover(undefined, undefined)"
									>
										<app-checkbox
											[value]="account.vestigingen.includes(vestiging.rVestiging.vestigingId)"
											(valueChange)="toggle(account, vestiging.rVestiging.vestigingId, $event)"
										/>
									</td>
								}
							</tr>
						}
					</tbody>
				</table>
			}
		}
	</div>
</section>
